import React, { useEffect, useState } from "react";
import {
  Page,
  Text,
  View,
  Document,
  Image as ReactPdfImage,
} from "@react-pdf/renderer";

// Custom.
import { TemplateProps } from "../global";
import { styles } from "./styles";
import { baseStyles } from "../styles";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { getContactName } from "@vocollege/app/dist/modules/VoHelpers";
import { getStringPlaceHolder } from "services/Utils";
import LogoSvg from "@vocollege/theme/dist/images/vocollege.svg";
import { convertSvgToImage } from "@vocollege/app/dist/modules/VoHelpers";

const CertificateTemplate: React.FC<TemplateProps> = (props) => {
  const { item } = props;
  const [logotype, setLogotype] = useState<any>(null);

  // Methods.
  const setImage = async () => {
    try {
      let convertedImage = await convertSvgToImage(LogoSvg, 260);
      setLogotype(convertedImage);
    } catch (error) {
      console.error(error);
    }
  };

  // Effects.

  useEffect(() => {
    setImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    //@ts-ignore
    <Document>
      {/*
 // @ts-ignore */}
      <Page size="A4" style={(baseStyles.page, styles.page)} wrap={false}>
        <View style={styles.decor}>
          <View style={baseStyles.section}>
            <Text style={styles.title}>
              {I18n.get.certificate.template.title}
            </Text>
            <Text style={styles.subtitle}>
              {I18n.get.certificate.template.subtitle}
            </Text>
          </View>
          <View style={baseStyles.section}>
            <Text style={styles.person}>
              {item &&
                (item.firstname || item.lastname) &&
                getContactName(item)}
            </Text>
            <Text style={styles.personalNumber}>
              {item && item.personal_number}
            </Text>
          </View>
          <View style={baseStyles.section}>
            {item && (
              <Text style={styles.text2}>
                {I18n.trans(I18n.get.vocertCertificate.template.text2, {
                  credits: item.credits || "xxxx",
                })}
              </Text>
            )}
          </View>

          <View style={baseStyles.grow}></View>
          <View style={baseStyles.section}>
            {item && item.educator && (
              <Text style={styles.educator}>{item.educator.title}</Text>
            )}
            {item && item.educator && item.educator.parentGroups[0] && (
              <Text style={styles.place}>
                {I18n.trans(I18n.get.diploma.template.place, {
                  college: item.educator.parentGroups[0].title,
                })}
              </Text>
            )}
            {item && <Text style={styles.date}>{item.date}</Text>}
          </View>
          <View style={[baseStyles.section, styles.footer]}>
            {item && item.principal && item.principal !== "" && (
              <View style={styles.signatures}>
                <View style={styles.signature}>
                  <Text style={styles.signaturePerson}>
                    {item.principal}
                    {/* {getContactName(item.principal)} */}
                  </Text>
                  <Text style={styles.signatureTitle}>
                    {I18n.get.certificate.template.principal}
                  </Text>
                </View>
              </View>
            )}
            <Text style={styles.educatorCertified}>
              {item &&
                item.educator &&
                I18n.trans(I18n.get.diploma.template.certifiedSince, {
                  educator: item.educator.title,
                  date: item.educator.certified,
                })}
              {(!item || !item.educator) && getStringPlaceHolder()}
            </Text>
          </View>
          {logotype && (
            <View style={[baseStyles.section, styles.logoWrapper]}>
              <ReactPdfImage src={logotype} style={styles.logo} />
            </View>
          )}
          {item && item.uid && item.uid.code && (
            <Text style={[baseStyles.uid, styles.uid]}>{item.uid.code}</Text>
          )}
        </View>
      </Page>
    </Document>
  );
};
export default CertificateTemplate;
